export const COTATO_LIGHT_THEME = 'light';
export const COTATO_DARK_THEME = 'dark';
export const THEME_CHANGE_TRANSITION = 'background 0.2s ease-in';
export const HEADER_HEIGHT = '4.5rem';
